module.exports = __webpack_public_path__ + "img/modelo3d-materiales-recopila.aa66b540.png";